import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {

  http = inject(HttpClient);

  email = '';

  urlRequested = '';

  isChange = signal(false);

  constructor() { }

  setEmail(emailPayload: string) {
    this.email = emailPayload;
  }

  setIsChange(value: any) {
    this.isChange.set(value)
  }
  getIsChange() {
    return this.isChange();
  }

  getEmail(){
    return this.email || JSON.parse(sessionStorage.getItem('email')|| '""') || '';
  }

  isLoggedin(){
    const isLogged = (this.email || JSON.parse(sessionStorage.getItem('email')|| '""')) ? true : false;
    this.isChange.set(isLogged)
    return isLogged;
  }

  getDocument(payload: any){
    const apiURL = environment.apiEndpoint + '/v1/file/get_signed_url';
    return this.http.post(apiURL, payload);
  }

  getUserRoleByEmail(userEMail: string) {
    const apiUrl = environment.UAM_ROLE +`/user/v1/roles?username=${userEMail}`;
    return this.http.get(apiUrl);
  }

  setUrlRequested(url: string){
    this.urlRequested = url;
  }

  getUrlRequested(){
    return this.urlRequested || '';
  }

  logout(){
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = '/login';
  }

}
